export function IconHome() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </svg>
  );
}

/** Иконка товаров (Material inventory_2 / коробка). */
export function IconProducts() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4h16v3z" />
    </svg>
  );
}

export function IconSettings() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M19.14 12.94c.04-.31.06-.63.06-.94 0-.31-.02-.63-.06-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.04.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
    </svg>
  );
}

/** Иконка уведомлений (Material bell). */
export function IconNotifications() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
    </svg>
  );
}

/** Иконка событий/уведомлений по образцу web-client (EventsIcon). */
export function IconEvents() {
  return (
    <svg width="20" height="20" viewBox="0 0 14 16" fill="currentColor" aria-hidden>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2C5.34315 2 4 3.34315 4 5H2C2 2.23858 4.23858 0 7 0C9.76142 0 12 2.23858 12 5H10C10 3.34315 8.65685 2 7 2Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11C1.10457 11 2 10.1046 2 9H4C4 11.2091 2.20914 13 0 13V11Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9C12 10.1046 12.8954 11 14 11V13C11.7909 13 10 11.2091 10 9H12Z"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M14 13H0V11H14V13Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M4 5V9H2V5H4Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12 5V9H10V5H12Z" />
      <path d="M9 14C9 15.1046 8.10457 16 7 16C5.89543 16 5 15.1046 5 14H9Z" />
    </svg>
  );
}

export function IconPerson() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  )
}

export function IconLogout() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
    </svg>
  );
}

export function IconMenu() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
    </svg>
  );
}

/** Иконка открытия меню как в web-client (navigation.svg). */
export function IconNavigation() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 5C15 5.55228 14.5523 6 14 6H4C3.44772 6 3 5.55228 3 5C3 4.44772 3.44772 4 4 4H14C14.5523 4 15 4.44772 15 5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 9C15 9.55228 14.5523 10 14 10H4C3.44772 10 3 9.55228 3 9C3 8.44772 3.44772 8 4 8H14C14.5523 8 15 8.44772 15 9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 13C15 13.5523 14.5523 14 14 14H4C3.44772 14 3 13.5523 3 13C3 12.4477 3.44772 12 4 12H14C14.5523 12 15 12.4477 15 13Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Вертикальное троеточие — меню действий (Material more_vert), как в web-client ContextVIcon. */
export function IconMoreVert() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
  );
}

/** Иконка удаления (Material delete/trash). */
export function IconDelete() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
    </svg>
  );
}

/** Иконка скачивания файла (Material file_download), как в web-client FileCards. */
export function IconDownload() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
    </svg>
  );
}

/** Иконка редактирования (Material edit/pencil). */
export function IconEdit() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
    </svg>
  );
}

export function IconChevronLeft() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </svg>
  );
}

export function IconChevronRight() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </svg>
  );
}

/** Иконка сворачивания панели как в web-client (close-panel-left.svg). */
export function IconClosePanelLeft() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4.5C9 4.22386 8.77614 4 8.5 4C8.22386 4 8 4.22386 8 4.5V19.5C8 19.7761 8.22386 20 8.5 20C8.77614 20 9 19.7761 9 19.5V4.5ZM8.5 2C7.11929 2 6 3.11929 6 4.5V19.5C6 20.8807 7.11929 22 8.5 22C9.88071 22 11 20.8807 11 19.5V4.5C11 3.11929 9.88071 2 8.5 2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5577 12.4856C15.3899 12.1836 15.3899 11.8164 15.5577 11.5144L18.4214 6.35979C18.6896 5.87701 18.5156 5.2682 18.0328 4.99999C17.5501 4.73178 16.9413 4.90572 16.673 5.38851L13.5396 11.0287C13.204 11.6328 13.204 12.3672 13.5396 12.9713L16.673 18.6115C16.9413 19.0943 17.5501 19.2682 18.0328 19C18.5156 18.7318 18.6896 18.123 18.4214 17.6402L15.5577 12.4856Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Иконка разворачивания панели как в web-client (open-panel.svg). */
export function IconOpenPanel() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 5.5C18 4.67157 17.3284 4 16.5 4C15.6716 4 15 4.67157 15 5.5V18.5C15 19.3284 15.6716 20 16.5 20C17.3284 20 18 19.3284 18 18.5V5.5ZM16.5 2C14.567 2 13 3.567 13 5.5V18.5C13 20.433 14.567 22 16.5 22C18.433 22 20 20.433 20 18.5V5.5C20 3.567 18.433 2 16.5 2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.47514 12.4856C7.64293 12.1836 7.64293 11.8164 7.47514 11.5144L4.6115 6.35979C4.34328 5.87701 4.51723 5.2682 5.00001 4.99999C5.4828 4.73178 6.0916 4.90572 6.35981 5.38851L9.49325 11.0287C9.82883 11.6328 9.82883 12.3672 9.49325 12.9713L6.35981 18.6115C6.0916 19.0943 5.4828 19.2682 5.00001 19C4.51723 18.7318 4.34328 18.123 4.6115 17.6402L7.47514 12.4856Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconChevronDown() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    </svg>
  );
}

/** Иконка заказов (Material assignment / документ с галочкой). */
export function IconOrders() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
    </svg>
  );
}

/** Иконка смен (Material schedule / часы с человеком). */
export function IconShifts() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" />
    </svg>
  );
}

/** Предстоящие смены — календарь / запланированные события (Material event). */
export function IconShiftsUpcoming() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
    </svg>
  );
}

/** Закрытые смены — завершено (Material check_circle). */
export function IconShiftsClosed() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </svg>
  );
}

/** Все смены — полный список (Material view_list). */
export function IconShiftsAll() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M3 14h4v-4H3v4zm0 5h4v-4H3v4zm0-10h4V5H3v4zm5 5h14v-4H8v4zm0 5h14v-4H8v4zM8 5v4h14V5H8z" />
    </svg>
  );
}

/** Иконка документа/файла (Material description). */
export function IconDocument({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
    </svg>
  );
}

/** Иконка «изображение не загружено» / «фото перечёркнуто» для заглушки при ошибке загрузки картинки. */
export function IconImageBroken({ size = 48 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="M21 15l-5-5L5 21" />
      <line x1="3" y1="3" x2="21" y2="21" />
    </svg>
  );
}
